import { getCateringSettings, updateCateringSettings } from './cateringSettings';
import { getEventSettings, updateEventSettings } from './eventSettings';

/**
 * Maps a page's `visibility` key (see PagesConstants) to the backend get/set for that page's
 * public visibility. Used by the Pages hub so a row's Hide/Show toggles real backend state.
 * The settings PUTs patch only the field sent, so other settings are preserved.
 */
const PAGE_VISIBILITY_HANDLERS = {
  events: {
    getVisible: (): Promise<boolean> => getEventSettings().then((settings) => settings.isEventsEnabled),
    setVisible: async (visible: boolean): Promise<void> => {
      await updateEventSettings({ isEventsEnabled: visible });
    }
  },
  catering: {
    getVisible: (): Promise<boolean> => getCateringSettings().then((settings) => settings.isCateringEnabled),
    setVisible: async (visible: boolean): Promise<void> => {
      await updateCateringSettings({ isCateringEnabled: visible });
    }
  }
};

export default PAGE_VISIBILITY_HANDLERS;
